import { Dialog, DialogType, Spinner } from '@fluentui/react';
import React from 'react';
import { App } from '../App';
import { Office365API } from '../services/o365';

export class AppLoader extends React.Component {
    state = {
        AppLoaded: false,
        settings: {} as any,
        showErrorMessage: false

    }
    public static instance: AppLoader;
    componentDidMount() {

        this.loadSettings();
    }
    render() {
        AppLoader.instance = this;
        if (this.state.showErrorMessage) {
            return <><Dialog
                hidden={false}

                dialogContentProps={{ type: DialogType.largeHeader, title: 'Cannot load application',subText:'There was an error reading the application settings from the backend. please try again later.' }}
                modalProps={{ isBlocking: true }}
            >
            </Dialog>
            </>
        }
        return this.state.AppLoaded ? <App /> : <><Spinner>App loading</Spinner></>;
    }

    loadSettings() {
        let settingURL = 'api/getSettings';
        if (window.location.hostname === 'localhost') {
            settingURL = 'sampleData/getSettings/localhost.dat';
        }
        fetch(settingURL).then((response) => {
            response.json().then((jsonData) => {

                this.setState({ settings: jsonData });
                new Office365API(this.state.settings.clientId, this.state.settings.tenantId);
                this.setLoadState();
            });
        }).catch((error) => {
            console.error(error);
            this.setState({ showErrorMessage: true });
        });
    }
    setLoadState() {
        if (this.state.settings !== undefined) {
            this.setState({ AppLoaded: true });
        }
    }
}